<template>
    <span v-if="!notitleneeded">
      <span class="edited_content" v-if="!editmode">
        <button class="edit_icon edit_icon_menu add-block-button" @click.prevent="editmode = true">
          <span class="material-icons ico">add_circle</span>
          {{linktext}}
        </button>
      </span>
      <div class="edit_field" v-if="editmode">
        <form id="edit_pagetext" method="post" @submit.prevent="createPage()">
          <input class="textinput" type="text" v-model="pagetitle" name="field_subpagetitle" :placeholder="placeholdertext">
          <input type="submit" name="submit_subpagetitle" value="Toevoegen" class="btn btn-primary">
        </form>
      </div>
    </span>
    <span v-else>
      <span class="edited_content" v-if="!editmode">
        <button class="edit_icon edit_icon_menu add-block-button" @click.prevent="createPage()">
          <span class="material-icons ico">add_circle</span>
          {{linktext}}
        </button>
      </span>
    </span>
</template>

<script>  

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
  props:{
    parentpageid: String,
    websiteid: String,
    linktext: String,
    placeholdertext: String,
    notitleneeded: Boolean,
    blockstyle: String
  },
  data: function(){
    return{
      editmode: false,
      pagetitle: ''
    }
  },
  methods: {
    createPage(){

        const requestOptions = {
          headers: authHeader()
        }

        const pageid = ''

        if(this.parentpageid == 'home'){
          //get pageid first
          this.pageid = 'home'
        } else {
          this.pageid = this.parentpageid
        }

        const data = {
          websiteid: this.websiteid,
          belongsto: this.pageid,
          pagetitle: this.pagetitle,
          blockstyle: this.blockstyle
        }

        console.log(data)

        axios.post(process.env.VUE_APP_ROOT_API+'/pages/', data, requestOptions)
        .then(response => {
            this.pagetitle = ''
            this.editmode = false
            this.$emit('clicked')
            console.log(response)
        })
        
    },
  }
}
</script>

<style scoped>
.add-block-button{
  background: #f6f6f6;
  border-radius: 6px;
  margin: 0 5px;
}
</style>
